import React, { useState } from "react"
import PropTypes from "prop-types"
import Client from "../api/Client"

const ApplicantActions = (props) => {
    const [checked, setChecked] = useState(props.jobApplication.attributes.favorite);
    const [hidding, setHidding] = useState(false);
    const [showing, setShowing] = useState(false);

    const hideJobApplication = () => {
        setHidding(true);
        Client.hideJobApplication(props.jobApplication.id).then(() => {
            props.onHide(props.jobApplication.id);
        }).finally(() => {
            setHidding(false);
        })
    }

    const showJobApplication = () => {
        setShowing(true);
        Client.showJobApplication(props.jobApplication.id).then(() => {
            props.onHide(props.jobApplication.id);
        }).finally(() => {
            setShowing(false);
        })
    }

    const variant = props.variant || 'stack';
    const isStar = variant === 'star';

    return (
        <div className={`job-application-actions${variant === 'row' ? ' job-application-actions--row' : ''}${isStar ? ' job-application-actions--star' : ''}`}>
            <label className={`btn-border-dark-sm job-application-favorite${checked ? ' is-favorited' : ''}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    disabled={!props.allowToggle}
                    onChange={() => {
                        if (props.allowToggle) {
                            Client.toggleFavorite(props.jobApplication.id)
                                .then(setChecked(!checked))
                        }
                    } }
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
                <span className={isStar ? 'sr-only' : 'ml-2'}>Favorite</span>
            </label>

            { !isStar && (
              <>
            <button
                onClick={ () => props.onModalOpen(props.jobApplication) }
                className="btn-border-dark-sm"
                data-test="share-in-modal"
            >
                Share
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 5.44444L8.55556 0V3.11111C3.11111 3.88889 0.777778 7.77778 0 11.6667C1.94444 8.94444 4.66667 7.7 8.55556 7.7V10.8889L14 5.44444Z" fill="#62607A"></path>
                </svg>
            </button>

            { !props.jobApplication.attributes.hidden && (
                <button
                    onClick={hideJobApplication}
                    className="btn-border-dark-sm"
                    disabled={hidding}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={14} height={14} fill="currentColor">
                        <path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" />
                    </svg>
                    <span className="ml-2">
                        { hidding ? 'Hiding...' : 'Hide' }
                    </span>
                </button>
            )}

            { props.jobApplication.attributes.hidden && (
                <button
                    onClick={showJobApplication}
                    className="btn-border-dark-sm"
                    disabled={showing}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={14} height={14} fill="currentColor">
                        <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
                    </svg>
                    <span className="ml-2">
                        { showing ? 'Unhiding...' : 'Unhide' }
                    </span>
                </button>
            )}
              </>
            )}
        </div>
    )
};

ApplicantActions.propTypes = {
    jobApplication: PropTypes.object.isRequired,
    allowToggle: PropTypes.bool.isRequired,
    onModalOpen: PropTypes.func,
    onHide: PropTypes.func,
    variant: PropTypes.string,
};

export default ApplicantActions;
